import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { integrationFiles } from './integration-files.js'
import { normalizeInstalledIntegrations } from './normalize-installed-integrations.js'

export function syncInstalledIntegrationManifests(
  cwd: string,
  config: ResolvedBetterstartConfig
): void {
  integrationFiles.syncInstalledManifests(cwd, config, normalizeInstalledIntegrations(config))
}
